import React from 'react';
import { Box, Switch, Typography } from '@mui/material';

interface BitrixDealOrCaseSwitchProps {
	isBitrixDeal: boolean;
	onChange: () => void;
	disabled?: boolean;
}

const BitrixDealOrCaseSwitch: React.FC<BitrixDealOrCaseSwitchProps> = ({
	isBitrixDeal,
	onChange,
	disabled = false,
}: BitrixDealOrCaseSwitchProps) => {
	return (
		<Box>
			<Box display="flex" justifyContent="space-between" width="300px" alignItems="center">
				<Typography variant="body1">Es un Deal de Bitrix</Typography>
				<Switch checked={isBitrixDeal} onChange={onChange} color="primary" disabled={disabled} />
			</Box>
			<Box display="flex" justifyContent="space-between" width="300px" alignItems="center">
				<Typography variant="body1">Es un caso</Typography>
				<Switch checked={!isBitrixDeal} onChange={onChange} color="primary" disabled={disabled} />
			</Box>
		</Box>
	);
};

export default BitrixDealOrCaseSwitch;
